import React from 'react';
import { Form, Checkbox, Segment, Grid, Menu } from 'semantic-ui-react';
import { getSKPD,getOPD } from '../../../../../_utils/localstorage';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import swal from 'sweetalert'

export default class FormProfile extends React.Component {
   constructor(props){
      super(props);
      this.state = {
         passwd:{
            new_pass:"",
            confirm_pass:"",
         },
         profile:{
               "username": "",
               "alamat": "",
               "nama": "",
               "jabatan": "",
               "kode": "",
               "contact": ""
            },
         skpd:"",
         opd:"",
         loading_passwd:false,
         loading_profile:false,
         is_update_passwd:false,
         is_update_profile:false
      }

      this.onChangePasswd = this.onChangePasswd.bind(this);
      this.onChangeProfile = this.onChangeProfile.bind(this);
      this.onSubmitPasswd = this.onSubmitPasswd.bind(this);
      this.onSubmitProfile = this.onSubmitProfile.bind(this);
      this.togglePasswd = this.togglePasswd.bind(this);
      this.toggleProfile = this.toggleProfile.bind(this);

   }

   togglePasswd = () => this.setState({ is_update_passwd: !this.state.is_update_passwd })
   toggleProfile = () => this.setState({ is_update_profile: !this.state.is_update_profile })
   componentDidMount = () => this.getProfile()

   getProfile(){
      fetch(`${BaseURLDev}/users/profile`,{ headers })
      .then(response => {
         return response.json();
      })
      .then(resJSON => {
         this.setState({
            profile:{
               ...this.state.data,
               "username": resJSON.data.user.username,
               "alamat": resJSON.data.alamat,
               "nama": resJSON.data.nama,
               "jabatan": resJSON.data.jabatan,
               "kode": resJSON.data.kode,
               "contact": resJSON.data.contact
            },
            skpd:`${resJSON.data.kd_urusan}.${resJSON.data.kd_bidang}.${resJSON.data.kd_unit}`,
            opd:`${resJSON.data.kd_urusan}.${resJSON.data.kd_bidang}.${resJSON.data.kd_unit}.${resJSON.data.kd_sub}`,
            loading:false
         })
      });
   }
   
   onSubmitProfile(e){
      this.setState({loading_profile:true});
      e.preventDefault();
      fetch(`${BaseURLDev}/users/profile`,{
         method: 'POST',
         headers,
         body: JSON.stringify(this.state.profile)
      })
      .then(response => {
         if (!response.ok) { 
            swal("", "Update data profil gagal", "error");
            this.setState({loading_profile:false});
            return Promise.reject(response.statusText);
         }
         else{
            this.setState({loading_profile:false})    
            swal("Update profile sukses", {icon: "success",});
         }
      })
   }

   onChangeProfile(e){
      let text = e.target.value.replace(/[^a-zA-Z0-9]/g, '')
      this.setState({profile:{...this.state.profile,[e.target.name]:text}})      
   }

   onChangePasswd = (e) => this.setState({passwd:{...this.state.passwd,[e.target.name]:e.target.value}})

   onSubmitPasswd(){
      const { new_pass, confirm_pass } = this.state.passwd;
      if(new_pass!=="" || confirm_pass!==""){
         if(new_pass.length<5){
            swal("Password terlalu pendek", {icon: "error",})
         }else{
            if(new_pass!==confirm_pass){
               swal("Kedua password harus cocok", {icon: "error",});
            }else{
               this.setState({loading_passwd:true})
               fetch(`${BaseURLDev}/users/passwd`,{
                  method: 'POST',
                  body: JSON.stringify({password:new_pass}),
                  headers
               })
               .then(res => res.json())
               .then(resJSON => {
                  this.setState({
                     new_pass:"",
                     confirm_pass:"",
                     loading_passwd:false
                  })
                  swal("", "Update password sukses", "success").then(()=>{
                     window.location.href = '/b/profile'
                  });
               });
            }
         }
      }else{
         swal("Password tidak boleh kosong", {icon: "error",});
      }
   }

   render() {
      const { username,nama,jabatan,kode,alamat,contact } = this.state.profile;
      const { loading_profile, skpd, opd } = this.state;
      return (
         <div>
         <Menu>
            <Menu.Item>
               OPD :{opd===""?"":getOPD(opd)}
            </Menu.Item>
            {/*<Menu.Item>
               SKPD :{getSKPD(this.state.skpd)}
            </Menu.Item>*/}            
         </Menu>
         <Grid>
            <Grid.Column width={8}>
               <Segment color='violet'>
                  <Form onSubmit={this.onSubmitProfile} loading={loading_profile}>
                     <Form.Input value={username} readOnly/>       
                     <Form.Input value={this.state.opd} readOnly />               
                     <Form.Input value={skpd===""?"":getSKPD(skpd)} readOnly />        
                     <Form.Input value={opd===""?"":getOPD(opd)} readOnly />        
                     <Form.Input value={kode} onChange={this.onChangeProfile} name="kode" placeholder="NIP/Kode Pegawai"/>
                     <Form.Input value={nama} onChange={this.onChangeProfile} name="nama" placeholder='Nama pegawai' />               
                     <Form.Input value={jabatan} onChange={this.onChangeProfile} name="jabatan" placeholder='Jabatan pegawai' />               
                     <Form.Input value={contact} onChange={this.onChangeProfile} name="contact" placeholder='Nomor contact' />               
                     <Form.TextArea value={alamat} onChange={this.onChangeProfile} placeholder='Alamat pegawai' name="alamat" />
                     <Checkbox 
                        label='Update data profile anda?' 
                        onChange={this.toggleProfile} 
                        checked={this.state.is_update_profile} /><br /><br />
                     <Form.Button positive disabled={!this.state.is_update_profile}>Update profile</Form.Button>
                  </Form>
               </Segment>
            </Grid.Column>
            <Grid.Column width={8}>
               <Segment color='violet'>
                  <Form onSubmit={this.onSubmitPasswd} loading={this.state.loading_passwd}>
                     <Form.Input type="password" value={this.state.passwd.new_pass} onChange={this.onChangePasswd} 
                        name="new_pass" placeholder='Password baru' />               
                     <Form.Input type="password" 
                        value={this.state.passwd.confirm_pass} 
                        onChange={this.onChangePasswd} 
                        name="confirm_pass" placeholder='Konfirmasi password' />    
                        
                        <Checkbox 
                        label='Ganti password akun anda?' 
                        onChange={this.togglePasswd} 
                        checked={this.state.is_update_passwd} /><br /><br />

                     <Form.Button positive disabled={!this.state.is_update_passwd}>Ganti Password</Form.Button>
                  </Form>
               </Segment>
            </Grid.Column>            
         </Grid>
         </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_profile/Profile.js